// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3UrEg","right":"styles_right__3Sh6o"};